import _ from 'lodash';
import { apiSearch, apiFetch, apiRemove } from '../utility';

export const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : 'terminal',
			dispatch,
			callback,
		});
	};
};

export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'terminal.get',
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'terminal.add',
			listNameToUpdate : 'terminalIds',
			params,
			dispatch,
			successMessage : `Terminal created successfully. 
				Click continue to return to the terminal page.`,
			onSuccessRedirectTo : '/logistics/terminals',
			callback,
		});
	};
};

export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'terminal.update',
			params,
			dispatch,
			successMessage : `Terminal updated successfully. 
				Click continue to return to the terminal page.`,
			onSuccessRedirectTo : '/logistics/terminals',
			callback,
		});
	};
};

export const remove = ({terminalId, callback = _.noop}) => {
	return dispatch => {
		apiRemove({
			base : 'terminal',
			id : terminalId,
			dispatch,
			callback,
		});
	};
};
